module.exports = __webpack_public_path__ + "static/media/Zinc Standing Seam.67775c5e.jpg";